exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dz-more {\n    display: block;\n    margin-bottom: 16px;\n    border: 2px dashed #CCDCE8;\n    width: 100%;\n    height: 100px;\n    box-sizing: border-box;\n    color: #CCDCE8;\n    font-size: 60px;\n    text-align: center;\n    line-height: 100px;\n    pointer-events: none;\n}\n", ""]);

// exports
